<script setup lang="ts">
import { computed } from "vue";

import { EDashboardType } from "@/app/data/dashboard/dashboard.types";
import { useFeatureFlag } from "@/composables/feature-flag/use-feature-flag";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { keyOf, useTypedIntl } from "@/locales/typed-intl";
import { ERouteName } from "@/router/router.type";
import { newSectionManagementFeatureFlag } from "@/services/feature-flags/env-feature-flags";

import DashboardDialog from "@/components/data/dashboard/dashboard-dialog.vue";
import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

interface IProps {
  noData: boolean | undefined;
  siteId: number;
}

const visible = defineModel<boolean>();

const props = defineProps<IProps>();

const { t, k } = useTypedIntl();
const { isEnvFeatureEnabled } = useFeatureFlag();

const MONO = 1;

const subtitleKeypath = computed<string>(() =>
  keyOf(k.data.dashboard.missingSurfaceArea.subtitle[props.noData ? "total" : "partial"][EDashboardType.MONOSITE]),
);
</script>

<template>
  <DashboardDialog v-model:visible="visible">
    <template #title>
      <h4>
        {{ t(k.data.dashboard.missingSurfaceArea.title) }}
      </h4>
    </template>

    <i18n-t
      class="whitespace-pre-line"
      :keypath="subtitleKeypath"
      tag="p"
    >
      <template #sitesManagementTab>
        <router-link
          :data-test-id="DATA_TEST_IDS.views.dashboard.links.sitesManagementLink"
          target="_blank"
          :to="{
            name: isEnvFeatureEnabled(newSectionManagementFeatureFlag)
              ? ERouteName.SITE_SECTIONS_TREE
              : ERouteName.SITE_SECTIONS,
            params: { siteId: props.siteId },
          }"
        >
          <HospitalityButton
            severity="link"
            size="xs"
          >
            {{ t(k.components.layout.sideMenu.sitesManagement({ count: MONO })) }}</HospitalityButton
          >
        </router-link>
      </template>
    </i18n-t>
  </DashboardDialog>
</template>
